import { STAGE_COLORS, STAGE_LABELS } from "../lib/stages";

export function StageBadge({ stage, size = "default", definition }) {
  const configuredColour = definition?.colour || definition?.color;
  const c = configuredColour
    ? { bg: `${configuredColour}20`, text: configuredColour, border: `${configuredColour}66` }
    : STAGE_COLORS[stage] || STAGE_COLORS.key_return;
  const label = definition?.display_name || definition?.name || STAGE_LABELS[stage] || "Workflow stage";
  return (
    <span
      className="stage-badge"
      style={{
        backgroundColor: c.bg,
        color: c.text,
        borderColor: c.border,
        fontSize: size === "sm" ? 10 : 11,
      }}
      data-testid={`stage-badge-${stage}`}
    >
      {label}
    </span>
  );
}

export function FlagPip({ kind }) {
  const colors = {
    rebooking: "#8B5CF6",
    storage: "#F59E0B",
    refurbishment: "#EF4444",
    summer_stay: "#0EA5E9",
    occupied: "#B91C1C",
  };
  const labels = {
    rebooking: "Rebook",
    storage: "Storage",
    refurbishment: "Refurb",
    summer_stay: "Summer Stay",
    occupied: "Occupied",
  };
  return (
    <span
      className="flag-pip"
      style={{ color: colors[kind] }}
      data-testid={`flag-${kind}`}
    >
      {labels[kind]}
    </span>
  );
}
